// Auto-generated mapping for Clipper Cargas placeholders.

import FacturarUnEnvioDeContado from './facturar-un-envio-de-contado.jsx';
import RevalorizacionDeEnvios from './revalorizacion-de-envios.jsx';
import ConsultaYReimpresionDeFc from './consulta-y-reimpresion-de-fc.jsx';
import EnviosDeContadoSinFactura from './envios-de-contado-sin-factura.jsx';
import OrdenesDeRetirosYServicios from './ordenes-de-retiros-y-servicios.jsx';
import StickersDeRecepcionDeCarga from './stickers-de-recepcion-de-carga.jsx';
import IngresoDeRemitos from './ingreso-de-remitos.jsx';
import ConfirmacionDeDespachos from './confirmacion-de-despachos.jsx';
import RecanalizadorDeCarga from './recanalizador-de-carga.jsx';
import FojasDeRuta from './fojas-de-ruta.jsx';
import ControlFiscalDeRutaDgr from './control-fiscal-de-ruta-dgr.jsx';
import StickersPorCartaDePorte from './stickers-por-carta-de-porte.jsx';
import TranscripcionGuiaDeSucursal from './transcripcion-guia-de-sucursal.jsx';
import IngresoDeRemitosDeSucursal from './ingreso-de-remitos-de-sucursal.jsx';
import PresupuestadorDeEnvios from './presupuestador-de-envios.jsx';
import DefinicionDeLineas from './definicion-de-lineas.jsx';
import BolsinesPorCliente from './bolsines-por-cliente.jsx';
import AuditoriaDeDespachos from './auditoria-de-despachos.jsx';
import CargaMasivaDeGuias from './carga-masiva-de-guias.jsx';
import ImportacionMasivaDeGuias from './importacion-masiva-de-guias.jsx';
import NovedadesEntregasConformeEnGral from './novedades-entregas-conforme-en-gral.jsx';
import NovedadesFaltaRecepcionDeRemito from './novedades-falta-recepcion-de-remito.jsx';
import NovedadesEnvioExtraviado from './novedades-envio-extraviado.jsx';
import NovedadesGuiaSinEntregarCargaRetenida from './novedades-guia-sin-entregar-carga-retenida.jsx';
import NovedadesEnvioCProblemas from './novedades-envio-c-problemas.jsx';
import NovedadesNoRecibidoEnDestino from './novedades-no-recibido-en-destino.jsx';
import NovedadesRemitoCancelado from './novedades-remito-cancelado.jsx';
import NovedadesRemitoRechazado from './novedades-remito-rechazado.jsx';
import NovedadesCambioDeDestino from './novedades-cambio-de-destino.jsx';
import NovedadesCambioDePagador from './novedades-cambio-de-pagador.jsx';
import NovedadesCambioDeCondicionDePago from './novedades-cambio-de-condicion-de-pago.jsx';
import NovedadesCambioDeDomicilio from './novedades-cambio-de-domicilio.jsx';
import NovedadesCambioDeDestinatario from './novedades-cambio-de-destinatario.jsx';
import NovedadesCambioDeRemitente from './novedades-cambio-de-remitente.jsx';

export const clipperCargasRoutes = {
  '/cargas/facturar-un-envio-de-contado': <FacturarUnEnvioDeContado />,
  '/cargas/revalorizacion-de-envios': <RevalorizacionDeEnvios />,
  '/cargas/consulta-y-reimpresion-de-fc': <ConsultaYReimpresionDeFc />,
  '/cargas/envios-de-contado-sin-factura': <EnviosDeContadoSinFactura />,
  '/cargas/ordenes-de-retiros-y-servicios': <OrdenesDeRetirosYServicios />,
  '/cargas/stickers-de-recepcion-de-carga': <StickersDeRecepcionDeCarga />,
  '/cargas/ingreso-de-remitos': <IngresoDeRemitos />,
  '/cargas/confirmacion-de-despachos': <ConfirmacionDeDespachos />,
  '/cargas/recanalizador-de-carga': <RecanalizadorDeCarga />,
  '/cargas/fojas-de-ruta': <FojasDeRuta />,
  '/cargas/control-fiscal-de-ruta-dgr': <ControlFiscalDeRutaDgr />,
  '/cargas/stickers-por-carta-de-porte': <StickersPorCartaDePorte />,
  '/cargas/transcripcion-guia-de-sucursal': <TranscripcionGuiaDeSucursal />,
  '/cargas/ingreso-de-remitos-de-sucursal': <IngresoDeRemitosDeSucursal />,
  '/cargas/presupuestador-de-envios': <PresupuestadorDeEnvios />,
  '/cargas/definicion-de-lineas': <DefinicionDeLineas />,
  '/cargas/bolsines-por-cliente': <BolsinesPorCliente />,
  '/cargas/auditoria-de-despachos': <AuditoriaDeDespachos />,
  '/cargas/carga-masiva-de-guias': <CargaMasivaDeGuias />,
  '/cargas/importacion-masiva-de-guias': <ImportacionMasivaDeGuias />,
  '/cargas/novedades/entregas-conforme-en-gral': <NovedadesEntregasConformeEnGral />,
  '/cargas/novedades/falta-recepcion-de-remito': <NovedadesFaltaRecepcionDeRemito />,
  '/cargas/novedades/envio-extraviado': <NovedadesEnvioExtraviado />,
  '/cargas/novedades/guia-sin-entregar-carga-retenida': <NovedadesGuiaSinEntregarCargaRetenida />,
  '/cargas/novedades/envio-c-problemas': <NovedadesEnvioCProblemas />,
  '/cargas/novedades/no-recibido-en-destino': <NovedadesNoRecibidoEnDestino />,
  '/cargas/novedades/remito-cancelado': <NovedadesRemitoCancelado />,
  '/cargas/novedades/remito-rechazado': <NovedadesRemitoRechazado />,
  '/cargas/novedades/cambio-de-destino': <NovedadesCambioDeDestino />,
  '/cargas/novedades/cambio-de-pagador': <NovedadesCambioDePagador />,
  '/cargas/novedades/cambio-de-condicion-de-pago': <NovedadesCambioDeCondicionDePago />,
  '/cargas/novedades/cambio-de-domicilio': <NovedadesCambioDeDomicilio />,
  '/cargas/novedades/cambio-de-destinatario': <NovedadesCambioDeDestinatario />,
  '/cargas/novedades/cambio-de-remitente': <NovedadesCambioDeRemitente />,
};
